(() => {
  if(window.ArtperestJourney || window.Shopify?.designMode)return;
  const endpoint='https://api.artperest.com',storageKey='ap-journey-visitor-v1';
  const uuid=value=>typeof value==='string'&&/^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/i.test(value);
  let visitor=null,tail=Promise.resolve();const jobs=new Map(),observers=new Set();
  const privacyReady=new Promise(resolve=>{
    if(window.Shopify?.customerPrivacy){resolve();return;}
    if(window.Shopify?.loadFeatures)window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(error)console.warn('Journey consent API unavailable');resolve();});
    else resolve();
  });
  const permitted=()=>window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true;
  const identity=()=>{
    if(visitor)return visitor;
    try{const saved=JSON.parse(localStorage.getItem(storageKey)||'null');if(uuid(saved?.id)&&saved.expires>Date.now())visitor=saved.id;}catch{/* Storage is optional. */}
    visitor ||=crypto.randomUUID();
    try{localStorage.setItem(storageKey,JSON.stringify({id:visitor,expires:Date.now()+90*86400000}));}catch{/* This page retains an in-memory identity. */}
    return visitor;
  };
  const send=(event,record={})=>{
    const task=async()=>{
      await privacyReady;if(!permitted())return;
      const {job,...fields}=record,body=JSON.stringify({visitorId:identity(),event,...fields});
      const path=job?'/v1/jobs/'+job.id+'/journey':'/v1/journey';
      for(let n=0;n<2;n++)try{
        const response=await fetch(endpoint+path,{method:'POST',credentials:'include',keepalive:true,headers:{'Content-Type':'application/json',...(job?{Authorization:'Bearer '+job.token}:{})},body,signal:AbortSignal.timeout(10000)});
        if(response.ok)return;if(response.status<500)throw Object.assign(Error('Journey rejected: '+response.status),{final:true});
      }catch(error){if(n||error.final){console.warn('Journey measurement unavailable',error.message);return;}}
    };
    tail=tail.then(task,task);return tail;
  };
  const attemptFor=job=>{let id=jobs.get(job.id);if(!id)try{id=sessionStorage.getItem('ap-journey-job:'+job.id);}catch{/* Optional browser storage. */}return uuid(id)?id:null;};
  const visible=async(event,job,element,image)=>{
    const attemptId=attemptFor(job);if(!attemptId||!element)return;
    const source=image?.src;if(image)try{await image.decode();}catch{return;}if(image&&image.src!==source)return;
    let intersecting=false,sent=false;
    const check=()=>{if(document.querySelector('dialog[open]'))return;if(!sent&&(!image||image.src===source)&&intersecting&&document.visibilityState==='visible'&&element.isConnected&&element.getClientRects().length){sent=true;observer.disconnect();observers.delete(observer);document.removeEventListener('visibilitychange',check);document.removeEventListener('close',check,true);void send(event,{job:{id:job.id,token:job.token},attemptId});}};
    const observer=new IntersectionObserver(entries=>{intersecting=entries.some(entry=>entry.isIntersecting&&entry.intersectionRatio>=0.05);check();},{threshold:0.05});
    observers.add(observer);document.addEventListener('visibilitychange',check);document.addEventListener('close',check,true);observer.observe(element);
  };
  window.ArtperestJourney={
    start(kind){const attemptId=crypto.randomUUID();void send('start',{attemptId,kind});return attemptId;},
    accepted(job,attemptId){if(!uuid(attemptId))return;jobs.set(job.id,attemptId);try{sessionStorage.setItem('ap-journey-job:'+job.id,attemptId);}catch{/* Optional browser storage. */}void send('accepted',{job:{id:job.id,token:job.token},attemptId});},
    visible,
  };
  const visit=()=>{if(document.visibilityState==='visible')void send('visit');};
  document.addEventListener('visibilitychange',visit);document.addEventListener('visitorConsentCollected',visit);visit();
  window.addEventListener('pageshow',visit);
  window.addEventListener('pagehide',()=>{for(const observer of observers)observer.disconnect();observers.clear();});
})();
